import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import leelaSpaceLogo from '../assets/Leela Space.png';
import { resolveThanksPageLanguageFromSearch } from '../utils/languageRouting.js';

const ThanksForPaymentPage = () => {
  const { t, i18n } = useTranslation('game');
  const [isLanguageReady, setIsLanguageReady] = useState(() => i18n.language === resolveThanksPageLanguageFromSearch(window.location.search));
  const languageFromQuery = useMemo(
    () => resolveThanksPageLanguageFromSearch(window.location.search),
    [],
  );

  useEffect(() => {
    let isMounted = true;

    if (i18n.language === languageFromQuery) {
      setIsLanguageReady(true);
      return () => {
        isMounted = false;
      };
    }

    i18n.changeLanguage(languageFromQuery).finally(() => {
      if (isMounted) {
        setIsLanguageReady(true);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [i18n, languageFromQuery]);

  if (!isLanguageReady) {
    return null;
  }

  return (
    <main className="payment-thanks-page">
      <section className="payment-thanks-card">
        <img className="payment-thanks-logo" src={leelaSpaceLogo} alt="Leela Space" />
        <h1>{t('thanksForPayment.title')}</h1>
        <p>
          {t('thanksForPayment.description')}{' '}
          <a href="https://leelaspace.com/" target="_blank" rel="noopener noreferrer">
            {t('thanksForPayment.linkText')}
          </a>
        </p>
      </section>
    </main>
  );
};

export default ThanksForPaymentPage;
